import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "left-content" };
const _hoisted_3 = { class: "right-content" };
import { computed, onBeforeUnmount, ref, } from 'vue';
import { i18n } from '@/locales';
import SubController from '@V/ShareManagement/ShareList/SubController.vue';
import HubSharesListTable from '@V/ShareManagement/ShareList/HubSharesListTable.vue';
import ShareStoreListTable from '@V/ShareManagement/ShareList/ShareStoreListTable.vue';
import CardSection from '@/components/Common/CardSection.vue';
import LoadingMask from '@/components/Common/LoadingMask.vue';
import { BusinessError } from '@/error';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import vuexStore from '@/vuex-store';
import TotalCount from '@/components/TotalCount.vue';
const lc = 'views.share_management.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const getterShareInfoTotalLength = computed(() => vuexStore.getters['shareManagement/shareList/getterShareInfoTotalLength']);
        const getterSelectedRowShareInfo = computed(() => vuexStore.getters['shareManagement/shareList/getterSelectedRowShareInfo']);
        const cardTitle = computed(() => {
            const title = getterSelectedRowShareInfo.value
                ? `${i18n.t(`${lc}share_store_list_title`)} / ${getterSelectedRowShareInfo.value.hubName}`
                : i18n.t(`${lc}share_store_list_title`);
            return `${title}`;
        });
        const isGetShareInfoFetching = ref(true);
        const isGetShareInfoError = ref(false);
        const handleGetShareInfoRequestProcess = async () => {
            try {
                isGetShareInfoFetching.value = true;
                isGetShareInfoError.value = false;
                await vuexStore.dispatch('shareManagement/shareList/getShareInfo');
            }
            catch (error) {
                if (error instanceof BusinessError) {
                    isGetShareInfoError.value = true;
                    vuexStore.dispatch(snackbarActionType.showError, {
                        message: error.reason ? error.message : 'common.unknown_error',
                    });
                }
            }
            finally {
                isGetShareInfoFetching.value = false;
            }
        };
        const isGetShareStoreListFetching = ref(false);
        const isGetShareStoreListError = ref(false);
        const handleGetShareStoreListRequestProcess = async (hubId) => {
            try {
                vuexStore.dispatch('shareManagement/shareList/resetShareStoreList');
                vuexStore.dispatch('app/endFetching');
                isGetShareStoreListFetching.value = true;
                isGetShareStoreListError.value = false;
                await vuexStore.dispatch('shareManagement/shareList/getShareStoreList', hubId);
            }
            catch (error) {
                if (error instanceof BusinessError) {
                    isGetShareStoreListError.value = true;
                    vuexStore.dispatch(snackbarActionType.showError, {
                        message: error.reason ? error.message : 'common.unknown_error',
                    });
                }
            }
            finally {
                isGetShareStoreListFetching.value = false;
            }
        };
        const handleClickHubSharesListTableRow = async (hubId, hubName) => {
            handleGetShareStoreListRequestProcess(hubId);
            vuexStore.dispatch('shareManagement/shareList/setSelectedRowShareInfo', {
                hubId,
                hubName,
            });
        };
        onBeforeUnmount(() => {
            vuexStore.dispatch('shareManagement/shareList/resetShareInfo');
            vuexStore.dispatch('shareManagement/shareList/resetShareStoreList');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(SubController, { "handle-request-process": handleGetShareInfoRequestProcess }),
                    _createVNode(TotalCount, null, {
                        default: _withCtx(() => [
                            _createTextVNode(" 총 " + _toDisplayString(getterShareInfoTotalLength.value) + " 건 ", 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(HubSharesListTable, {
                        "is-fetching": isGetShareInfoFetching.value,
                        "is-error": isGetShareInfoError.value,
                        "handle-click-row": handleClickHubSharesListTableRow
                    }, null, 8 /* PROPS */, ["is-fetching", "is-error"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(CardSection, { title: cardTitle.value }, {
                        default: _withCtx(() => [
                            _createVNode(ShareStoreListTable, {
                                "is-fetching": isGetShareStoreListFetching.value,
                                "is-error": isGetShareStoreListError.value
                            }, null, 8 /* PROPS */, ["is-fetching", "is-error"]),
                            _createVNode(LoadingMask, {
                                "is-fetching": isGetShareStoreListFetching.value,
                                opacity: 0,
                                color: "primary",
                                size: "32"
                            }, null, 8 /* PROPS */, ["is-fetching"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["title"])
                ])
            ]));
        };
    }
});
